module.exports = __webpack_public_path__ + "img/bwzykr-currency-guide.1129989d.png";